import React, {createContext, useContext, useEffect, useState} from "react";

export const WidgetContext = createContext(null);

export const useWidgetContext = () => useContext(WidgetContext);

export const WidgetContextProvider = ({isWidget, widgetType, settings = {}, children}) => {

    const [widgetSettings, setWidgetSettings] = useState(settings);

    useEffect(() => {
        setWidgetSettings(settings)
    }, [settings])

    const context = {
        isWidget,
        widgetType,
        widgetSettings,
        setWidgetSettings
    };

    return (
        <WidgetContext.Provider value={context}>
            {children}
        </WidgetContext.Provider>
    );
}
